import React from 'react';
import logo from './Logo.svg';
import './App.css';
import {Navigation} from './components/Navigation';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
    
    <div className="App">
    
      <header className="App-header">
      
        <img src={logo} className="App-logo" alt="logo" />
        <p style={{color:"#51565C"}}>
          <b>NEARSHORE.DC</b><br/>SOFTWARE DEVELOPMENT CAMPUS
        </p>
       
        <div className="App-header-text">
          <p>
            Bitte haben Sie noch etwas Geduld. Unser neuer und informativer Webauftritt geht in Kürze an den Start!
          </p>
          <p>
          Please have a little patience. Our new and informative website will be launched soon!
          </p>
          <p>
          Por favor, tenha um pouco de paciência. Nosso novo e informativo site será lançado em breve!
          </p>
        </div>
        {/*
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        */}
         
      </header>
     
    </div>
    
    </BrowserRouter>
  );
}

export default App;
